import React, { FC } from "react";

export interface UserTypeCardProps {
  isActive?: boolean;
  text: string;
  image: any;
  className: string;
  onClick: () => void;
}

export const UserTypeCard: FC<UserTypeCardProps> = ({
  className,
  image,
  text,
  isActive,
  onClick,
}) => {
  return (
    <div
      className={`${className} w-full md:w-36 md:h-36 rounded-xl relative mb-2 md:mb-0 md:mr-4 cursor-pointer`}
      role="radio"
      onClick={onClick}
    >
      {isActive && (
        <div className="w-4 h-4 border-2 border-white rounded-full bg-accent-500 absolute right-2 top-2" />
      )}
      <div className="flex md:flex-col pl-4 md:pl-0 py-2 md:py-0 items-center md:justify-center w-full h-full">
        <img
          className="w-12 md:w-14 h-12 md:h-14 rounded-full bg-white border-2 border-solid border-white mr-4 md:mr-0"
          src={image}
        />
        <h4
          className={`m-0 md:mt-4 font-semibold ${
            isActive ? "text-white" : "text-primary-500"
          }`}
        >
          {text}
        </h4>
      </div>
    </div>
  );
};
